import React from 'react'
import Label from '../control-label'
import { __, sprintf } from 'StylistParent/i18n';
import { pick } from 'lodash';

import Dashicon from 'Components/dashicon';
import IconButton from 'Components/icon-button';
// import Tooltip from '../../../tooltip'

import { mediaUpload } from 'StylistParent/utils/mediaupload';
import MediaUpload from './media-upload';

import Button from 'Components/button';
// import { MediaUpload } from '@wordpress/blocks';

/* function MyMediaUploader() {
	return (
		<MediaUpload
			onSelect={ ( media ) => console.log( 'selected ' + media.length ) }
			type="image"
			value={ mediaId }
			render={ ( { open } ) => (
				<Button onClick={ open }>
					Open Media Library
				</Button>
			) }
		/>
	);
} */

/* Import CSS */
import './index.scss'

class UploadButton extends React.Component {
	componentDidMount = () => {
		const { attributes, setAttributes } = this.props;
		// const { id, url = '' } = attributes;

	/* 	if ( ! id && url.indexOf( 'blob:' ) === 0 ) {
			getBlobByURL( url )
				.then(
					( file ) =>
						mediaUpload(
							[ file ],
							( [ image ] ) => {
								setAttributes( { ...image } );
							},
							'image'
						)
				);
		}*/
	}

	onSelectImage = ( media ) => {
		this.props.changeValue( media.url )
		// Pass to the Control component an object with the next properties.
		/*
		this.props.changeValue(
			pick(
				media, [
					'alt',
					'id',
					'caption',
					'url',
					'height',
					'width'
				]
			) )
		 */
	}

	render() {
		const { value } = this.props;
		return (
			<div>
				<MediaUpload
					onSelect={ this.onSelectImage }
					type="image"
					value={ value }
					render={ ( { open } ) => (
						<Button onClick={ open } className="button-primary button-large">
							{ __( 'Open Media Library' ) }
						</Button>
					) }
				/>
			</div>
		)
	}
}

export default UploadButton;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/upload-button/index.jsx